import { useEffect, useState } from "react";
import { APIHandlerV1 } from "hooks/api-handler-v1";
export function UseLazyApiCall({
  url,
  method,
  paramsData,
  isBioMechanics,
  isAbsoluteUrl,
}: any) {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>();

  async function getData(props: any) {
    const localData = props?.params || paramsData;
    const localUrl = props?.url || url;

    let apiResponseInitial = null;
    try {
      setIsLoading(true);
      const { data: apiResponse } = await APIHandlerV1({
        method,
        url: localUrl,
        data: localData,
        isBioMechanics,
        isAbsoluteUrl,
      });
      setData(apiResponse);
      apiResponseInitial = apiResponse;
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
    return apiResponseInitial;
  }

  return [getData, { data, isLoading, error }];
}
